module.exports = __webpack_public_path__ + "static/media/eye.0378ce58.png";